import { Theme, useTheme } from '@chakra-ui/react';
import { ChakraAvatar, ChakraAvatarProps } from 'app/components/Core';
import {
  getAvatarColorsArray,
  getRandomColor,
} from 'app/components/Core/ChakraAvatar/utils';
import { getAvatarImage } from 'app/utils/utils';
import { ProfileCard } from 'types/profile';

export interface AvatarDefaultProps extends ChakraAvatarProps {
  userCard: Partial<ProfileCard>;
  usersLength: number;
  index: number;
}

export const AvatarDefault = ({
  userCard,
  usersLength,
  index,
  ...rest
}: AvatarDefaultProps) => {
  const theme = useTheme<Theme>();
  const randomColor = getRandomColor(
    getAvatarColorsArray(theme),
    userCard.initials
  );

  return (
    <ChakraAvatar
      key={userCard.guid}
      src={getAvatarImage(userCard.profileImages)}
      initials={userCard.initials}
      colors={
        userCard.avatarColors || {
          background: randomColor[200],
          text: randomColor[500],
        }
      }
      size="sm"
      borderWidth="0.38px"
      zIndex={-(usersLength - (index + 1))}
      {...rest}
    />
  );
};
